<template>
  <div>
    <div class="dragMark" :style="{display: isDrag ? 'block' : 'none'}"></div>
      <Draggable @stopDrag="stopDragging" @startDrag="startDragging" :elWidth="timeWidth" :elHeight="38">
        <div ref="vueDraggableRef" class="paper" :style="{ width: timeWidth + 'px' }">
          <div class="papername" :title="userInfo.username || userInfo.realName">{{ userInfo.username || userInfo.realName }}</div>
          <div style="display: flex">
            <span class="icon"></span>
            <CountDown
              class="eachendcompiler--countDown"
              :tipText="tipText"
              :isClear="isClear"
              dayTxt="天"
              :timeDistance="timeDistance"
            />
            <span
              v-if="isNeedSubmit"
              v-show="newSubmitBtn"
              class="paperbtn"
              @click="submit"
              >交 卷</span
            >
          </div>
        </div>
      </Draggable>
  </div>
</template>
<script>
import CountDown from '@/components/CountDown2.vue';
import Draggable from './MyDrag.vue';
import { mapState } from 'vuex';
export default {
  components: { Draggable, CountDown },
  props: {
    tipText: {
      type: String,
      default: '',
    },
    isClear: {
      type: Boolean,
      default: false,
    },
    timeDistance: {
      type: Number,
      default: 0,
    },
    isNeedSubmit: {
      default: false,
      type: Boolean,
    },
    newSubmitBtn: {
      default: false,
      type: Boolean,
    },
    timingFlag: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isDrag: false,
    };
  },
  computed: {
    timeWidth() {
      if (this.timingFlag === 0) {
        return this.isNeedSubmit && this.newSubmitBtn ? 370 : 330;
      } else {
        return this.isNeedSubmit && this.newSubmitBtn ? 390 : 350;
      }
    },
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
  methods: {
    submit() {
      this.$emit('handleSubmit');
    },
    // 开始拖动时将遮罩层显示
    startDragging() {
      this.isDrag = true
    },
    // 停止拖动是隐藏遮罩层
    stopDragging() {
      this.isDrag = false
    },
  },
};
</script>
<style lang="less" scoped>
.bigBox{
  width: calc(100vw - 100px);
  height: calc(100vh - 100px);
  background: #000;
  opacity: .2;
  position: absolute;
  top: 0;
  margin: auto;
}
.dragMark{
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin: auto;
  background: #000;
  opacity: 0;
  z-index: 1;
}
.paper {
  line-height: 36px;
  display: flex;
  width: 352px;
  color: #fff;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 5px;
  position: relative;
  .papername {
    font-size: 14px;
    max-width: 88px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    background: rgba(0, 0, 0, 0.8);
    border-radius: 5px 0 0 5px;
    text-align: center;
    padding: 0 16px;
  }

  .icon {
    display: inline-block;
    width: 15px;
    height: 15px;
    line-height: 36px;
    background: url('~@/assets/Frame@2x.png') no-repeat;
    background-size: contain;
    align-self: center;
    margin: 0 8px 0 13px;
  }
  .paperbtn {
    width: 76px;
    height: 34px;
    background: #fa9e00;
    color: #fff;
    border-radius: 5px;
    position: absolute;
    text-align: center;
    right: 1px;
    top: 1px;
    cursor: pointer;
    &:hover {
      background: #fbb72e;
    }
    &:active {
      background: #f09000;
    }
  }
}
.eachendcompiler--countDown {
  font-size: 13px;
}
</style>
<style lang="less">
.HandInPaperSubBtn {
  position: absolute;
  top: 3px;
  // right: 50%;
}
</style>
